module.exports = __webpack_public_path__ + "static/media/realtalk_sd_dx6_deactive76511cea503ab6f8c32f692848329126.webp";